export default class extends Controller {
  static targets = ["select"];

  connect() {
    App.DynamicSelect.initEl(this.selectTarget);
    App.DynamicSelect.onChange(this.selectTarget, this.submitFilter.bind(this));
  }

  submitFilter() {
    window.location = App.Helpers.formDataAsURLQueryString(this.element, this.url);
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get("url");
  }
};



// WEBPACK FOOTER //
// ./app/components/filters/assets/javascript/filters-select-controller.js